import { useQuery } from '@tanstack/react-query';

import { Transit } from '@e-origin/shared';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

export const useTransit = (id: string) =>
  useQuery({
    queryKey: ['transit', id],
    queryFn: async (): Promise<Transit> => {
      try {
        const { data } = await request({
          path: `transits/${id}`,
          method: 'GET',
          authenticate: true,
        });
        return data.transit;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch transit details');
      }
    },
    enabled: !!id,
  });
